import {inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {

  isLoading = signal(false);
  title = signal('loading.title');
  message = signal('loading.default_message');
  private readonly translate = inject(TranslateService);

  showLoading(title?: string, message?: string) {
    this.isLoading.set(true);

    this.title.set(
      title && title.trim().length > 0
        ?  this.translate.instant(title)
        : 'loading.title'
    );

    this.message.set(
      message && message.trim().length > 0
        ? this.translate.instant(message)
        : 'loading.default_message'
    );
  }

  hideLoading() {
    this.isLoading.set(false);
    this.title.set('loading.title');
    this.message.set('loading.default_message');
  }
}

